import {Component, Injector, Input} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {AssociationService} from "./services/association.service";
import {AdminMenuService} from "../../layout/admin-menu.service";

@Component({
    selector: 'app-provider-certification-list',
    templateUrl: './provider-certification-list.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class ProviderCertificationListComponent extends BasePageComponentDirective<any> {

    certifications: any[] = [];
    showCloseSearch = false;
    @Input() providerId: number;

    constructor(
        injector: Injector,
        private associationService: AssociationService,
        private adminMenuSvc: AdminMenuService
    ) {
        super(injector);
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.query();
    }

    query(): void {
        this.tableLoading = true;
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['certificationTitle'];
        this.associationService.getCertificationsByProviderId(this.pageQuery, this.providerId).then(r => {
            this.certifications = r.content;

            this.page.emit(r);
        });
    }

    searchUser($event: any) {
        if ($event.key === 'Enter') {
            this.searchTerm = this.pageQuery.search;
            this.query();
            this.showCloseSearch = true;
        }
    }

    clearSearch() {
        this.searchTerm = '';
        this.pageQuery.search = '';
        this.query();
        this.showCloseSearch = false;
    }

    viewCert(certificationId: number) {
        this.adminMenuSvc.changeMessage({ icon: 'article', label: 'Certifications', route: '/office/new-certification', active: false });
        this.router.navigate(['/office/new-certification/detail', certificationId]).then();
    }

    mergeAttendanceTypes(data: any[]) {
        return data.map(item => item.attendanceTypeLabel).join(", ");
    }
}
